import React from "react";
import CheckBox from "../../../../components/checkbox";
import Input from "../../../../components/input";
import { DataView } from "../../../../styles/elements/main";
import { FormGroup, FormRow, StyledLabel } from "../../../../styles/forms/main";
const ClientPricingDetails = ({
    isEditable,
    addNewCondition,
    handleOnChangeSelect,
    setSalesConditions,
    salesConditions,
    salesWorkingConditionIsValid,
    clientProjectData,
}) => (
    <div>
        <h3>Client Pricing Details</h3>

        <FormRow>
            <FormGroup>
                <Input
                    step="0.01"
                    disableWithBorder={false}
                    isEditable={isEditable || addNewCondition}
                    label="Truck price per month"
                    name="truckPricePerMonth"
                    type="number"
                    onChange={(e) => {
                        addNewCondition &&
                            handleOnChangeSelect(e.target.value, "truckPricePerMonth");
                        setSalesConditions({
                            ...salesConditions,
                            truckPricePerMonth: e.target.value,
                        });
                    }}
                    required
                    value={salesConditions?.truckPricePerMonth}
                    min="1"
                    error={
                        !salesWorkingConditionIsValid &&
                        ((isEditable &&
                            (salesConditions?.truckPricePerMonth === 0 ||
                                salesConditions?.truckPricePerMonth === "")) ||
                            (addNewCondition &&
                                (salesConditions?.truckPricePerMonth === 0 ||
                                    salesConditions?.truckPricePerMonth === "")))
                    }
                />
            </FormGroup>
            <FormGroup>
                <Input
                    step="0.01"
                    disableWithBorder={false}
                    isEditable={isEditable || addNewCondition}
                    label="Extra Day Price"
                    name="extraDayPrice"
                    type="number"
                    onChange={(e) => {
                        addNewCondition && handleOnChangeSelect(e.target.value, "extraDayPrice");
                        setSalesConditions({
                            ...salesConditions,
                            extraDayPrice: e.target.value,
                        });
                    }}
                    required
                    value={salesConditions?.extraDayPrice}
                    min="1"
                    error={
                        !salesWorkingConditionIsValid &&
                        ((isEditable &&
                            (salesConditions?.extraDayPrice === 0 ||
                                salesConditions?.extraDayPrice === "")) ||
                            (addNewCondition &&
                                (salesConditions?.extraDayPrice === 0 ||
                                    salesConditions?.extraDayPrice === "")))
                    }
                />
            </FormGroup>
        </FormRow>
        <FormRow>
            <FormGroup>
                <Input
                    step="0.01"
                    disableWithBorder={false}
                    isEditable={isEditable || addNewCondition}
                    label="Extra Working Hour Price"
                    name="extraHoursPrice"
                    type="number"
                    onChange={(e) => {
                        addNewCondition && handleOnChangeSelect(e.target.value, "extraHourPrice");
                        setSalesConditions({
                            ...salesConditions,
                            extraHourPrice: e.target.value,
                        });
                    }}
                    required
                    value={salesConditions?.extraHourPrice}
                    min="1"
                    error={
                        !salesWorkingConditionIsValid &&
                        ((isEditable &&
                            (salesConditions?.extraHourPrice === 0 ||
                                salesConditions?.extraDayPrice === "")) ||
                            (addNewCondition &&
                                (salesConditions?.extraHourPrice === 0 ||
                                    salesConditions?.extraHourPrice === "")))
                    }
                />
            </FormGroup>
            <FormGroup>
                <Input
                    step="0.01"
                    disableWithBorder={false}
                    isEditable={isEditable || addNewCondition}
                    label="Extra Kilometer Price"
                    name="extraKiloMeterPrice"
                    type="number"
                    onChange={(e) => {
                        addNewCondition &&
                            handleOnChangeSelect(e.target.value, "extraUnitDistancePrice");
                        setSalesConditions({
                            ...salesConditions,
                            extraUnitDistancePrice: e?.target?.value,
                        });
                    }}
                    required
                    value={salesConditions?.extraUnitDistancePrice}
                    min="1"
                    error={
                        !salesWorkingConditionIsValid &&
                        ((isEditable &&
                            (salesConditions?.extraUnitDistancePrice === 0 ||
                                salesConditions?.extraUnitDistancePrice === "")) ||
                            (addNewCondition &&
                                (salesConditions?.extraUnitDistancePrice === 0 ||
                                    salesConditions?.extraUnitDistancePrice === "")))
                    }
                />
            </FormGroup>
        </FormRow>
        <FormRow>
            <FormGroup>
                <Input
                    disableWithBorder={false}
                    isEditable={isEditable || addNewCondition}
                    label="Over Night Stay Price %"
                    name="overNightPrice"
                    type="number"
                    onChange={(e) => {
                        addNewCondition && handleOnChangeSelect(e.target.value, "overnightPrice");
                        setSalesConditions({
                            ...salesConditions,
                            overnightPrice: e.target.value,
                        });
                    }}
                    required={salesConditions?.workingOvernight}
                    value={salesConditions?.overnightPrice}
                    min="1"
                    max="100"
                    error={
                        !salesWorkingConditionIsValid &&
                        ((isEditable &&
                            (salesConditions?.overnightPrice === 0 ||
                                salesConditions?.overnightPrice === "")) ||
                            (addNewCondition &&
                                (salesConditions?.overnightPrice === 0 ||
                                    salesConditions?.overnightPrice === "")))
                    }
                />
            </FormGroup>
            <FormGroup>
                <Input
                    disableWithBorder={false}
                    isEditable={isEditable || addNewCondition}
                    label="Truck daily price"
                    name="truckDailyPrice"
                    type="number"
                    onChange={(e) => {
                        addNewCondition && handleOnChangeSelect(e.target.value, "truckDailyPrice");
                        setSalesConditions({
                            ...salesConditions,
                            truckDailyPrice: e.target.value,
                        });
                    }}
                    required={clientProjectData?.projectType === "Daily rental"}
                    value={salesConditions?.truckDailyPrice}
                    min="1"
                    error={
                        !salesWorkingConditionIsValid &&
                        ((isEditable &&
                            clientProjectData?.projectType === "Daily rental" &&
                            (salesConditions?.truckDailyPrice === 0 ||
                                salesConditions?.truckDailyPrice === "")) ||
                            (addNewCondition &&
                                (salesConditions?.truckDailyPrice === 0 ||
                                    salesConditions?.truckDailyPrice === "")))
                    }
                />
            </FormGroup>
        </FormRow>
        {(isEditable || addNewCondition) && (
            <FormRow>
                <FormGroup>
                    <CheckBox
                        label="Exclude Fuel & Oil"
                        name="excludeGasAndOil"
                        type="checkbox"
                        onChange={(e) => {
                            addNewCondition &&
                                handleOnChangeSelect(e.target.checked, "excludeGasAndOil");
                            setSalesConditions({
                                ...salesConditions,
                                excludeGasAndOil: e.target.checked,
                            });
                        }}
                        value={salesConditions?.excludeGasAndOil}
                    />
                </FormGroup>
            </FormRow>
        )}
        {salesConditions?.excludeGasAndOil && (
            <FormRow>
                <FormGroup>
                    <Input
                        disableWithBorder={false}
                        isEditable={isEditable || addNewCondition}
                        step="0.01"
                        label="Oil Price per Kilometer"
                        name="oilPricePerKilometer"
                        type="number"
                        onChange={(e) => {
                            addNewCondition &&
                                handleOnChangeSelect(e.target.value, "oilPricePerKilometer");
                            setSalesConditions({
                                ...salesConditions,
                                oilPricePerKilometer: e.target.value,
                            });
                        }}
                        required={salesConditions?.excludeGasAndOil}
                        placeholder="0"
                        value={salesConditions?.oilPricePerKilometer}
                        min="1"
                        error={
                            !salesWorkingConditionIsValid &&
                            ((isEditable &&
                                (salesConditions?.oilPricePerKilometer === 0 ||
                                    salesConditions?.oilPricePerKilometer === "")) ||
                                (addNewCondition &&
                                    (salesConditions?.oilPricePerKilometer === 0 ||
                                        salesConditions?.oilPricePerKilometer === "")))
                        }
                    />
                </FormGroup>
                <FormGroup>
                    <Input
                        disableWithBorder={false}
                        isEditable={isEditable || addNewCondition}
                        step="0.01"
                        label="Fuel Price per Kilometer"
                        name="fuelPricePerKilometer"
                        type="number"
                        onChange={(e) => {
                            addNewCondition &&
                                handleOnChangeSelect(e.target.value, "fuelPricePerKilometer");
                            setSalesConditions({
                                ...salesConditions,
                                fuelPricePerKilometer: e.target.value,
                            });
                        }}
                        required={salesConditions?.excludeGasAndOil}
                        placeholder="0"
                        value={salesConditions?.fuelPricePerKilometer}
                        min="1"
                        error={
                            !salesWorkingConditionIsValid &&
                            ((isEditable &&
                                (salesConditions?.fuelPricePerKilometer === 0 ||
                                    salesConditions?.fuelPricePerKilometer === "")) ||
                                (addNewCondition &&
                                    (salesConditions?.fuelPricePerKilometer === 0 ||
                                        salesConditions?.fuelPricePerKilometer === "")))
                        }
                    />
                </FormGroup>
                {(isEditable || addNewCondition) && (
                    <FormGroup>
                        <StyledLabel>Total Gas & Oil Price </StyledLabel>

                        {salesConditions?.kiloMeters &&
                        salesConditions?.fuelPricePerKilometer &&
                        salesConditions?.oilPricePerKilometer ? (
                            <DataView>
                                {Number(salesConditions?.kiloMeters) *
                                    (Number(salesConditions?.fuelPricePerKilometer) +
                                        Number(salesConditions?.oilPricePerKilometer))}
                            </DataView>
                        ) : (
                            "N/A"
                        )}
                    </FormGroup>
                )}
            </FormRow>
        )}
        <FormRow>
            <FormGroup>
                <Input
                    step="0.01"
                    disableWithBorder={false}
                    isEditable={isEditable || addNewCondition}
                    label="Helper Daily Wage"
                    name="helperWage"
                    type="number"
                    onChange={(e) => {
                        addNewCondition && handleOnChangeSelect(e.target.value, "pricePerHelper");
                        setSalesConditions({
                            ...salesConditions,
                            pricePerHelper: e.target.value,
                        });
                    }}
                    required={salesConditions.numberOfHelpers > 0}
                    value={salesConditions?.pricePerHelper ? salesConditions?.pricePerHelper : 0}
                    min="0"
                    error={
                        !salesWorkingConditionIsValid &&
                        ((isEditable &&
                            Number(salesConditions?.pricePerHelper) === 0 &&
                            Number(salesConditions.numberOfHelpers) > 0) ||
                            (addNewCondition &&
                                Number(salesConditions?.pricePerHelper) === 0 &&
                                Number(salesConditions.numberOfHelpers) > 0))
                    }
                />
            </FormGroup>
            <FormGroup>
                <Input
                    step="0.01"
                    disableWithBorder={false}
                    isEditable={isEditable || addNewCondition}
                    label="Delegate Monthly Wage"
                    name="delegateWage"
                    type="number"
                    onChange={(e) => {
                        addNewCondition && handleOnChangeSelect(e.target.value, "pricePerDelegate");
                        setSalesConditions({
                            ...salesConditions,
                            pricePerDelegate: e.target.value,
                        });
                    }}
                    required={salesConditions.deliveryDelegate > 0}
                    value={salesConditions?.pricePerDelegate}
                    min="0"
                    error={
                        !salesWorkingConditionIsValid &&
                        ((isEditable &&
                            Number(salesConditions?.pricePerDelegate) === 0 &&
                            Number(salesConditions.deliveryDelegate) > 0) ||
                            (addNewCondition &&
                                salesConditions?.pricePerDelegate === 0 &&
                                salesConditions.deliveryDelegate > 0))
                    }
                />
            </FormGroup>
        </FormRow>
    </div>
);
export default ClientPricingDetails;
